export const DELETE_POOL_REQUESTS_REQUEST = 'DELETE_POOL_REQUESTS_REQUEST';

export const deletePoolRequestsRequest = ( ids ) => ({
    type: DELETE_POOL_REQUESTS_REQUEST,
    payload: {
        ids,
    }
});
